export enum RoofWallFramingType {
  NONE = "NONE",
  AUTO = "AUTO",
  STICK_FRAMING = "STICK_FRAMING",
}
